import React from "react";
import { CheckCircle2, AlertCircle, AlertTriangle } from "lucide-react";

interface AdherenceCellProps {
  value: number | null;
}

const AdherenceCell: React.FC<AdherenceCellProps> = ({ value }) => {
  // Only "no data" (null) shows a dash. A genuine 0% — every rostered slot
  // missed — must render (red) rather than be hidden as if unmeasured.
  if (value === null) {
    return <span className="text-sm text-greyscale-text-caption">–</span>;
  }

  let tier: "good" | "warn" | "bad";
  if (value >= 94) tier = "good";
  else if (value >= 90) tier = "warn";
  else tier = "bad";

  let color: string;
  let Icon: typeof CheckCircle2;
  let srLabel: string;
  if (tier === "good") {
    color = "text-emerald-600";
    Icon = CheckCircle2;
    srLabel = "Good adherence: ";
  } else if (tier === "warn") {
    color = "text-amber-500";
    Icon = AlertCircle;
    srLabel = "At-risk adherence: ";
  } else {
    color = "text-red-500";
    Icon = AlertTriangle;
    srLabel = "Below-target adherence: ";
  }

  return (
    <span
      className={`text-sm font-semibold inline-flex items-center gap-xxxs ${color}`}
    >
      <Icon size={12} aria-hidden="true" />
      <span className="sr-only">{srLabel}</span>
      {value}%
    </span>
  );
};

export default AdherenceCell;
